export const GL_ERROR_NOTIFICATION = 'global/ERROR_NOTIFICATION'
export const GL_SUCCESS_NOTIFICATION = 'global/SUCCESS_NOTIFICATION'

export const errorNotification = (message) => ({ type: GL_ERROR_NOTIFICATION, message })
export const successNotification = (message) => ({ type: GL_SUCCESS_NOTIFICATION, message })
